import { createNotitiaUI } from "@lr-notitia/notitia-ui";
import router from "../router";

export default createNotitiaUI({
	accentColor: "#81c784",
	router: router,
	theme: {
		use: true,
		persist: true,
	},
});
